import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;

  & > * + * {
    margin-inline-start: 8px !important;
  }
`;

export const Check = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: ${({ theme, checked }) =>
    (checked && theme.colors.primaryMain) || theme.colors.white};
  border: 1px solid
    ${({ theme, checked }) => (checked && theme.colors.primaryMain) || theme.colors.primaryMain};
  border-radius: 4px;
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    top: 3px;
    display: ${({ checked }) => (checked && 'inline') || 'none'};
    width: 8px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.primaryMain};
    border: 2px solid ${({ theme }) => theme.colors.white};
    border-top: 0;
    border-right: 0;
    transform: rotate(-45deg);
  }
`;

export const Label = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.gr600};
`;
